import { type ReactElement } from 'react';
import { usePrincipal } from '@/core/auth/appToken';
import { tierFromRole, type RoleTier } from '@/models/role';

interface RequireRoleProps {
  /** Minimum role tier required. CEO > LEAD > EMPLOYEE. */
  readonly tier: RoleTier;
  readonly children: React.ReactNode;
}

const tierOrder: Record<RoleTier, number> = {
  CEO: 3,
  LEAD: 2,
  EMPLOYEE: 1,
};

/**
 * Renders children only if the user's role tier — derived from the backend-issued principal
 * (E01 §5/§6), not Entra ID-token claims — meets the required tier; otherwise renders nothing.
 */
export function RequireRole({ tier, children }: RequireRoleProps): ReactElement | null {
  const principal = usePrincipal();
  const userTier = tierFromRole(principal?.role);

  if (userTier === null || tierOrder[userTier] < tierOrder[tier]) {
    return null;
  }

  return <>{children}</>;
}
